export const GET_JOBS = "GET_JOBS";
export const ADD_JOBS = "ADD_JOBS";
export const UPDATE_JOBS = "UPDATE_JOBS";
export const DELETE_JOBS = "DELETE_JOBS";
